import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { thirdPartyAgreementKeys } from './thirdPartyAgreementKeys';

// One id per detail-page visit to an agreement; invoice notices are keyed by it so none outlive the visit.
export function useThirdPartyInvoiceVisit(vrm: string, reference: string): string {
    const queryClient = useQueryClient();
    const agreement = `${vrm}:${reference}`;
    const [visit, setVisit] = useState(() => ({ agreement, id: uuidv4() }));
    let current = visit;
    if (visit.agreement !== agreement) {
        current = { agreement, id: uuidv4() };
        setVisit(current);
    }
    const visitId = current.id;

    useEffect(
        () => () => {
            queryClient.removeQueries({
                queryKey: thirdPartyAgreementKeys.invoiceNotice(vrm, reference, visitId),
                exact: true,
            });
        },
        [queryClient, vrm, reference, visitId],
    );

    return visitId;
}
